module.exports = __webpack_public_path__ + "static/media/ifta-awards-02-12-22.ac3a1de5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ifta-awards-02-12-22.webp
// module id = 127
// module chunks = 0